<template>
  <div id="app">
    <!--    <img alt="Vue logo" src="./assets/logo.png">-->
    <!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <router-view />
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'
import api, { geSysConfig, } from '@/common/js/api'
import { setStore } from '@/store/massageStore.js';
import axios from "axios";
export default {
  name: 'App',
  components: {
    // HelloWorld
  },
  created() {
    this.loginFun()
  },
  methods: {
    loginFun() {
      axios.post(api.auth_login, { account: 'default', captcha: '验证码', password: '123456' }).then(res => {
        if (res.data.code == 200) {
          this.$cookies.set('token', res.data.data);
          // this.$router.push("/")
          // this.geSysConfigInfo()
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
    geSysConfigInfo() {
      geSysConfig().then(res => {
        let data = res.data
        setStore('footer_msg', data)
        setStore('userAgreement', { userAgreement: data.userAgreement, privacyAgreement: data.privacyAgreement })
        document.title = data.browserTitle
        let iconUrl = api.img_url + data.browserIcon
        let link = document.querySelector('link[rel="icon"]')
        if (link && link.href) {
          link.href = iconUrl
        } else {
          const newLink = document.createElement('link')
          newLink.ref = 'icon'
          newLink.href = iconUrl
          document.head.append(newLink)
        }
        if (data.innerLogo) {
          this.homeIconUrl = api.img_url + data.innerLogo
          localStorage.setItem('homeIconUrl_Img', this.homeIconUrl)
        }
      })
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

li {
  list-style-type: none;
}

.no-text {
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
  /* Standard syntax */
}

.ellipsis-text {
  overflow: hidden;
  /* 确保超出容器的文本被隐藏 */
  white-space: nowrap;
  /* 防止文本换行 */
  text-overflow: ellipsis;
  /* 超出部分显示省略号 */
}

.course-catalog .el-collapse {
  border: none;
}

.course-catalog .el-collapse-item__header {
  border: none;
  background-color: #f8fafb;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
  appearance: none;
}
</style>
